import { Attributes, Model, NeoModel, Rules, Validation } from '@singularsystems/neo-core';

@NeoModel
export default class IssuerAccrualScheduleReportCriteria extends Model.CriteriaBase {

    @Rules.Required()
    @Attributes.Nullable()
    public issuerId: number | null = null;

    // Client only properties / methods

    @Attributes.NoTracking()
    public issuerName: string = "";

    protected addBusinessRules(rules: Validation.Rules<this>) {
        super.addBusinessRules(rules);
    }

    public toString(): string {
        return "Issuer Client Schedule Report Criteria";
    }
}